
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gifting",
      function () {
        return require("private-next-pages/gifting/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gifting"])
      });
    }
  